export default "__VITE_ASSET__DZP_a$ov__"